/* lp.js - GENERATED by lp-src/build.mjs from lp-src/js/*.js. Do not edit by hand. */

/* ===== 00-core.js ===== */
/* LP core: section registry, theme-editor events, page-wide product state bus,
   anchor scrolling, money formatting, cart helper, Okendo aggregate.
   Every later partial is its own IIFE and registers with window.LP:

     (function () {
       if (!window.LP) return;
       window.LP.register('fit', function (root) {
         // bind listeners scoped to root …
         return function destroy() { … };   // optional
       });
     })();
*/
(function () {
  'use strict';
  if (window.LP && window.LP.__ready) return;

  var LP = (window.LP = window.LP || {});
  LP.__ready = true;

  var PHONE_MQ = '(max-width: 749.98px)';
  var REDUCED_MQ = '(prefers-reduced-motion: reduce)';
  var OKENDO_STORE = '3a91de02-6e2b-4ffb-b0f1-6374ac951d4c';

  /* ---------------- Utilities ---------------- */

  LP.qs = function (sel, root) {
    return (root || document).querySelector(sel);
  };

  LP.qsa = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  LP.emit = function (target, name, detail) {
    var ev = new CustomEvent(name, { bubbles: true, detail: detail });
    (target || document).dispatchEvent(ev);
    return ev;
  };

  LP.isPhone = function () {
    return window.matchMedia(PHONE_MQ).matches;
  };

  LP.reducedMotion = function () {
    return window.matchMedia(REDUCED_MQ).matches;
  };

  LP.designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------- Page id & A/B arm (D30) ---------------- */

  /* sections/lp-skin.liquid stamps its hidden marker with data-lp-page
     (template.suffix, e.g. 'lp-nurses-a') and data-ab ('a' | 'b', omitted when
     the suffix does not end in -a / -b). lp.js is deferred, so it is parsed.
     LP.page = { suffix, arm }; arm is '' when unknown. */
  LP.page = (function () {
    var marker = document.querySelector('[data-lp="skin"]');
    var suffix = (marker && marker.getAttribute('data-lp-page')) || '';
    var arm = ((marker && marker.getAttribute('data-ab')) || '').toLowerCase();
    if (arm !== 'a' && arm !== 'b') arm = '';
    return { suffix: suffix, arm: arm };
  })();
  if (LP.page.arm) document.documentElement.setAttribute('data-ab', LP.page.arm);

  var CTA_FALLBACK_SEL = 'a.lp-btn, button.lp-btn, a.lp-link';

  /* Tag CTAs for analytics (Lucky Orange, GA4): every [data-lp-cta] in scope
     gets data-ab = the arm. Buttons/links in an LP section without an explicit
     data-lp-cta get "<data-lp name>-cta" first, so forgotten CTAs are tagged.
     Sections that create CTAs at runtime call LP.stampCtas(theirRoot). */
  LP.stampCtas = function (scope) {
    scope = scope || document;
    var list = LP.qsa(CTA_FALLBACK_SEL, scope);
    if (scope.nodeType === 1 && scope.matches && scope.matches(CTA_FALLBACK_SEL)) list.unshift(scope);
    list.forEach(function (el) {
      if (el.hasAttribute('data-lp-cta')) return;
      var root = el.closest('[data-lp]');
      if (!root) return;
      el.setAttribute('data-lp-cta', root.getAttribute('data-lp') + '-cta');
    });
    if (!LP.page.arm) return;
    var ctas = LP.qsa('[data-lp-cta]', scope);
    if (scope.nodeType === 1 && scope.hasAttribute('data-lp-cta')) ctas.unshift(scope);
    ctas.forEach(function (el) {
      if (el.getAttribute('data-ab') !== LP.page.arm) el.setAttribute('data-ab', LP.page.arm);
    });
  };

  /* Format integer cents in the store's active currency. "$129.00";
     LP.money(12900, { trim: true }) -> "$129". */
  LP.money = function (cents, opts) {
    var value = (Number(cents) || 0) / 100;
    var trim = !!(opts && opts.trim) && value % 1 === 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: trim ? 0 : 2,
        maximumFractionDigits: trim ? 0 : 2,
      }).format(value);
    } catch (e) {
      return '$' + (trim ? String(value) : value.toFixed(2));
    }
  };

  /* Read a <script type="application/json"> payload, or null. */
  LP.json = function (el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  };

  /* ---------------- Registry ---------------- */

  var registry = {}; // name -> init(root) -> destroy?
  var instances = new Map(); // root element -> destroy fn | true
  var booted = false;

  function initRoot(root) {
    if (instances.has(root)) return;
    var init = registry[root.getAttribute('data-lp')];
    if (!init) return;
    instances.set(root, true);
    try {
      var destroy = init(root);
      if (typeof destroy === 'function') instances.set(root, destroy);
    } catch (err) {
      if (window.console) console.error('[LP] init "' + root.getAttribute('data-lp') + '" failed', err);
    }
  }

  function destroyRoot(root) {
    var destroy = instances.get(root);
    instances.delete(root);
    if (typeof destroy === 'function') {
      try {
        destroy();
      } catch (err) {
        if (window.console) console.error('[LP] destroy failed', err);
      }
    }
  }

  function rootsWithin(scope) {
    var list = LP.qsa('[data-lp]', scope);
    if (scope && scope.nodeType === 1 && scope.hasAttribute('data-lp')) list.unshift(scope);
    return list;
  }

  LP.initWithin = function (scope) {
    rootsWithin(scope || document).forEach(initRoot);
  };

  LP.destroyWithin = function (scope) {
    rootsWithin(scope || document).forEach(destroyRoot);
  };

  /* LP.register(name, init): init(root) runs once per [data-lp="name"]
     element, in document order, after every partial has registered. */
  LP.register = function (name, init) {
    registry[name] = init;
    if (booted) LP.qsa('[data-lp="' + name + '"]').forEach(initRoot);
  };

  /* ---------------- Keyboard-scrollable rows ---------------- */

  /* .lp-table-scroll / .lp-scroll-row become horizontal scrollers at narrow
     widths, often with nothing focusable inside (size chart, timeline, tiles).
     Safari does not make such scrollers focusable, so while one overflows it
     gets tabindex="0" and a name (WCAG 2.1.1); the tabindex goes again when it
     fits. A ResizeObserver also catches charts un-hidden by a tab switch. */
  var SCROLLER_SEL = '.lp-table-scroll, .lp-scroll-row';
  var scrollerObserver =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            syncScroller(entry.target);
          });
        })
      : null;

  function scrollerLabel(el) {
    var inner = el.querySelector('[role="table"][aria-label], table[aria-label]');
    if (inner) return inner.getAttribute('aria-label');
    var caption = el.querySelector('caption');
    if (caption && caption.textContent.trim()) return caption.textContent.trim();
    var section = el.closest('.lp-section');
    var heading = section && section.querySelector('h1, h2, .lp-h2');
    return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function syncScroller(el) {
    var overflows = el.scrollWidth > el.clientWidth + 1;
    if (overflows && !el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('data-lp-scroll-focus', '');
      var tag = el.tagName;
      if (tag !== 'UL' && tag !== 'OL' && !el.hasAttribute('role')) el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
        var label = scrollerLabel(el);
        if (label) el.setAttribute('aria-label', label);
      }
    } else if (!overflows && el.hasAttribute('data-lp-scroll-focus')) {
      el.removeAttribute('tabindex');
      el.removeAttribute('data-lp-scroll-focus');
    }
  }

  LP.initScrollers = function (scope) {
    LP.qsa(SCROLLER_SEL, scope || document).forEach(function (el) {
      syncScroller(el);
      if (scrollerObserver) scrollerObserver.observe(el);
    });
  };

  function boot() {
    if (booted) return;
    booted = true;
    LP.initWithin(document);
    LP.initScrollers(document);
    LP.stampCtas(document);
  }

  // lp.js is deferred, so the DOM is parsed when it runs. Wait one
  // microtask so every partial in the bundle has registered first.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    Promise.resolve().then(boot);
  }

  /* ---------------- Theme editor ---------------- */

  document.addEventListener('shopify:section:load', function (e) {
    LP.initWithin(e.target);
    LP.initScrollers(e.target);
    LP.stampCtas(e.target);
    measureHeader();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    LP.destroyWithin(e.target);
    if (scrollerObserver) {
      LP.qsa(SCROLLER_SEL, e.target).forEach(function (el) {
        scrollerObserver.unobserve(el);
      });
    }
  });

  function relayBlockEvent(type) {
    return function (e) {
      var root = e.target && e.target.closest ? e.target.closest('[data-lp]') : null;
      if (!root) return;
      root.dispatchEvent(
        new CustomEvent(type, {
          detail: { blockId: e.detail && e.detail.blockId, load: !!(e.detail && e.detail.load), target: e.target },
        })
      );
    };
  }

  // Sections listen on their root: root.addEventListener('lp:block-select', e => e.detail.blockId)
  document.addEventListener('shopify:block:select', relayBlockEvent('lp:block-select'));
  document.addEventListener('shopify:block:deselect', relayBlockEvent('lp:block-deselect'));

  /* ---------------- Product state bus ---------------- */

  LP.state = {
    product: 'primary', // 'primary' | 'secondary'
    variantId: null,
    colorName: '',
    size: '',
    productTitle: '',
    price: null, // cents
    image: '', // URL of the active colour's first image
    rating: null, // number, e.g. 4.7
    count: null, // review count
    url: '', // active product URL
    available: null, // selected variant availability
  };

  var stateSet = false;
  var stateOwner = null;

  /* Merge a partial and broadcast `lp:state` on document (detail = full state). */
  LP.setState = function (partial) {
    Object.assign(LP.state, partial || {});
    stateSet = true;
    document.dispatchEvent(new CustomEvent('lp:state', { detail: Object.assign({}, LP.state) }));
    return LP.state;
  };

  /* Subscribe to state; fn(state) runs now if a source has published, and on
     every change. Returns an unsubscribe function (return it from destroy). */
  LP.subscribe = function (fn) {
    function handler(e) {
      fn(e.detail);
    }
    document.addEventListener('lp:state', handler);
    if (stateSet) fn(Object.assign({}, LP.state));
    return function () {
      document.removeEventListener('lp:state', handler);
    };
  };

  /* Ask the state owner (the buy box) to switch product. */
  LP.requestProduct = function (which) {
    if (which !== 'primary' && which !== 'secondary') return;
    document.dispatchEvent(new CustomEvent('lp:request-product', { detail: { product: which } }));
  };

  /* The first buy box on the page owns the state. Returns true for the owner. */
  LP.claimStateOwner = function (root) {
    if (stateOwner && stateOwner !== root && document.documentElement.contains(stateOwner)) return false;
    stateOwner = root;
    return true;
  };

  LP.releaseStateOwner = function (root) {
    if (stateOwner === root) stateOwner = null;
  };

  /* ---------------- Sticky offsets & anchors ---------------- */

  // Height of a site header that is still sticky (lp-skin "static_header" off).
  function measureHeader() {
    var header = document.querySelector('.site-header-section');
    var h = 0;
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') h = header.offsetHeight;
    }
    document.documentElement.style.setProperty('--lp-sticky-top', h + 'px');
    return h;
  }

  /* Would the desktop product bar be showing with the page scrolled to
     document position y? Mirrors lp-sticky-bar's rule (D63): shown once the
     page is past the bar's height while the first buy box's add-to-cart
     button is out of view and either above the viewport or the whole buy box
     is off screen. No buy box: shown once scrolled. */
  function topBarShownAt(y, barH) {
    if (y <= barH) return false;
    var atc = document.querySelector('[data-lp="buy-box"] [data-lp-atc]');
    if (!atc) return true;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var py = window.pageYOffset;
    var a = atc.getBoundingClientRect();
    var aTop = a.top + py - y;
    var aBottom = a.bottom + py - y;
    if (aBottom > 0 && aTop < vh) return false; // button in view
    if (aBottom <= 0) return true; // button above the viewport
    var box = atc.closest('[data-lp="buy-box"]');
    if (!box) return true;
    return box.getBoundingClientRect().top + py - y >= vh; // whole buy box below
  }

  /* Pixels covered at the top of the viewport by sticky chrome. The desktop
     bar's wrapper may be 0px tall (the bar overlays the page), so measure the
     inner .lp-sticky-bar, falling back to the wrapper. With a target element
     (anchor jumps), the bar only counts when it will be showing once the page
     has scrolled to that target: a jump to #buy lands 12px under the header,
     a jump past the buy box clears the bar too. Without a target it counts
     whenever the bar can show (the old behaviour). */
  LP.stickyOffset = function (target) {
    var total = measureHeader();
    var wrap = document.querySelector('.lp-sticky-bar-wrap');
    if (wrap && !LP.isPhone()) {
      var pos = window.getComputedStyle(wrap).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var inner = wrap.querySelector('.lp-sticky-bar');
        var barH = Math.max(inner ? inner.offsetHeight : 0, wrap.offsetHeight);
        if (target && target.getBoundingClientRect) {
          var y = target.getBoundingClientRect().top + window.pageYOffset - total - 12;
          if (topBarShownAt(y, barH)) total += barH;
        } else {
          total += barH;
        }
      }
    }
    return total;
  };

  /* Desktop top bar shown/hidden (lp-sticky-bar): sets --lp-top-bar-h on
     :root (height px when visible, else 0px) and html.lp-top-bar-shown. */
  LP.setTopBar = function (visible, height) {
    var on = !!visible;
    var h = on ? Math.max(0, Number(height) || 0) : 0;
    document.documentElement.style.setProperty('--lp-top-bar-h', h + 'px');
    document.documentElement.classList.toggle('lp-top-bar-shown', on);
  };

  /* Smooth-scroll to an element or "#id" below the sticky chrome. */
  LP.scrollTo = function (target, opts) {
    var el = typeof target === 'string' ? document.getElementById(target.replace(/^#/, '')) : target;
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - LP.stickyOffset(el) - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: LP.reducedMotion() ? 'auto' : 'smooth' });
    if (!opts || opts.focus !== false) {
      if (!el.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) {
        el.setAttribute('tabindex', '-1');
      }
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        /* noop */
      }
    }
    if (el.id && (!opts || opts.updateHash !== false) && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + el.id);
    }
    return true;
  };

  /* Delegated clicks:
     - [data-lp-set-product="primary|secondary"] -> LP.requestProduct(...)
     - a[href^="#"] inside an LP section, or any [data-lp-scroll="<id>"] -> LP.scrollTo */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var setter = e.target.closest('[data-lp-set-product]');
    if (setter) LP.requestProduct(setter.getAttribute('data-lp-set-product'));

    var trigger = e.target.closest('[data-lp-scroll], [data-lp] a[href^="#"]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-lp-scroll') || trigger.getAttribute('href') || '';
    id = id.replace(/^#/, '');
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    LP.scrollTo(el);
  });

  window.addEventListener('resize', measureHeader, { passive: true });

  /* ---------------- Phone bottom bar ---------------- */

  /* Reserve space under the page for the phone bottom buy bar. */
  LP.setBottomBar = function (visible, height) {
    document.body.classList.toggle('lp-has-bottom-bar', !!visible);
    if (height) document.documentElement.style.setProperty('--lp-bottom-bar-h', height + 'px');
    /* Keep keyboard focus from being scrolled under the fixed bar (WCAG 2.4.11). */
    document.documentElement.style.scrollPaddingBottom = visible
      ? 'calc(' + ((Number(height) || 64) + 12) + 'px + env(safe-area-inset-bottom, 0px))'
      : '';
  };

  /* ---------------- Cart ---------------- */

  /* Add a variant; resolves with Shopify's response. Uses the theme API
     (opens the cart drawer). Rejects with an Error whose message is the
     shopper-facing text (Shopify's 422 `description` when present).
     properties (optional) become line-item properties; on lp-* templates the
     hidden _lp property records the page/arm (D30; checkout hides "_" keys). */
  LP.addToCart = function (variantId, quantity, properties) {
    var qty = Number(quantity) || 1;
    var props = Object.assign(
      {},
      LP.page.suffix && /^lp-/.test(LP.page.suffix) ? { _lp: LP.page.suffix } : {},
      properties && typeof properties === 'object' && !Array.isArray(properties) ? properties : {}
    );
    var hasProps = Object.keys(props).length > 0;
    if (window.UovoTheme && typeof window.UovoTheme.addToCart === 'function') {
      var call = hasProps
        ? window.UovoTheme.addToCart(variantId, qty, props)
        : window.UovoTheme.addToCart(variantId, qty);
      return Promise.resolve(call).catch(function (err) {
        throw LP.cartError(err);
      });
    }
    var item = { id: Number(variantId), quantity: qty };
    if (hasProps) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) throw LP.cartError({ description: data.description || data.message, status: res.status });
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
          return data;
        });
    }).catch(function (err) {
      /* HTTP errors above are already normalised (they carry .status);
         network TypeErrors ("Failed to fetch") get the friendly text. */
      if (err && err.status != null) throw err;
      throw LP.cartError(err);
    });
  };

  LP.CART_ERROR_TEXT = 'Something went wrong. Please try again.';

  LP.cartError = function (err) {
    var text = (err && err.description) || '';
    var e = new Error(text || LP.CART_ERROR_TEXT);
    e.status = err && err.status;
    return e;
  };

  /* ---------------- Okendo aggregate ---------------- */

  var okendoCache = {};

  function okendoOne(id, storeId) {
    var key = storeId + ':' + id;
    if (!okendoCache[key]) {
      var url =
        'https://api.okendo.io/v1/stores/' + encodeURIComponent(storeId) +
        '/products/shopify-' + encodeURIComponent(id) + '/review_aggregate';
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
      okendoCache[key] = fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('Okendo ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var a = json && json.reviewAggregate;
          if (!a) throw new Error('Okendo: no aggregate');
          return a;
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
        });
      // Let a failed request be retried by a later caller.
      okendoCache[key].catch(function () {
        delete okendoCache[key];
      });
    }
    return okendoCache[key];
  }

  /* LP.okendoAggregate(productIds, storeId?) -> Promise<{
       count, total, avg (1 decimal), avgText ('4.7'),
       levels: {5,4,3,2,1} counts, recommendCount, recommend (% rounded), products }>
     Sums across ids. Rejects if any request fails or there are no reviews, so
     callers keep their server-rendered defaults: LP.okendoAggregate(ids).then(render).catch(() => {}) */
  LP.okendoAggregate = function (productIds, storeId) {
    var ids = (Array.isArray(productIds) ? productIds : [productIds])
      .map(function (id) {
        return String(id == null ? '' : id).replace(/^shopify-/, '').trim();
      })
      .filter(function (id) {
        return /^\d+$/.test(id);
      })
      .filter(function (id, i, arr) {
        return arr.indexOf(id) === i;
      });
    if (!ids.length || !window.fetch) return Promise.reject(new Error('Okendo: no product ids'));
    var store = storeId || OKENDO_STORE;
    return Promise.all(ids.map(function (id) { return okendoOne(id, store); })).then(function (list) {
      var out = { count: 0, total: 0, levels: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }, recommendCount: 0, products: ids.length };
      list.forEach(function (a) {
        out.count += Number(a.ratingAndReviewCount) || 0;
        out.total += Number(a.ratingAndReviewValuesTotal) || 0;
        out.recommendCount += Number(a.recommendationCount) || 0;
        var lv = a.ratingAndReviewCountByLevel || {};
        for (var n = 1; n <= 5; n++) out.levels[n] += Number(lv['level' + n + 'Count']) || 0;
      });
      if (!out.count) throw new Error('Okendo: no reviews');
      out.avg = Math.round((out.total / out.count) * 10) / 10;
      out.avgText = out.avg.toFixed(1);
      out.recommend = Math.round((out.recommendCount / out.count) * 100);
      return out;
    });
  };

  /* ---------------- Page skin (sections/lp-skin.liquid) ---------------- */

  LP.register('skin', function (root) {
    var skin = root.getAttribute('data-skin') || 'nurses';
    document.documentElement.setAttribute('data-lp-skin', skin);
    measureHeader();

    // Remove the site-wide exit-intent popup (blocks/ai_gen_block_76b58b2) so it
    // never shows, never writes its 7-day localStorage flag and never locks body
    // scroll (it sets body.style.overflow = 'hidden'). Removing the custom element
    // fires its disconnectedCallback, which drops the mouseleave listener.
    // CSS from lp-skin also hides it; in the editor we only hide it.
    if (root.hasAttribute('data-hide-exit-popup')) {
      var popups = LP.qsa('[class^="ai-exit-intent-popup-"], [class*=" ai-exit-intent-popup-"]');
      popups.forEach(function (el) {
        if (el.classList.contains('active')) document.body.style.overflow = '';
        if (!LP.designMode) el.remove();
      });
    }

    // Turn the site-wide announcement link (e.g. to /collections/mens-shoes) into
    // plain text so paid visitors stay on this page (lp-skin "unlink_announcement").
    // CSS from lp-skin also disables pointer events; in the editor we leave the link.
    if (root.hasAttribute('data-unlink-announcement') && !LP.designMode) {
      LP.qsa('.announcement-bar__item > a').forEach(function (a) {
        var span = document.createElement('span');
        span.className = a.className;
        span.textContent = a.textContent;
        a.replaceWith(span);
      });
    }

    return function () {
      document.documentElement.removeAttribute('data-lp-skin');
    };
  });
})();

/* ===== 10-buy-box.js ===== */
/* LP buy box (sections/lp-buy-box.liquid): product / colour / size selection, gallery, add to cart.
   The first buy box on the page owns the page's product state: it publishes LP.setState(...) and
   answers LP.requestProduct('primary' | 'secondary') from the toggle, lp-fit and lp-closing-cta, and
   'lp:request-add' from the product bar (runs its own add to cart; detail.promise resolves to
   'added' | 'error' | 'skipped').
   The server renders the default product's default colour; this script re-renders on change.
   URL (owner only, never in the theme editor): on load ?variant= (wins), ?gender= and ?color= preselect;
   shopper gender / colour changes write gender= and color= back with history.replaceState (D51, D69). */
(function () {
  'use strict';
  var LP = window.LP;
  if (!LP) return;

  var MAIN_WIDTHS = [540, 720, 900, 1080, 1440, 1800];
  // The gallery's rendered width; mirrors main_sizes in sections/lp-buy-box.liquid.
  var MAIN_SIZES =
    '(max-width: 749px) calc(100vw - 40px), (max-width: 989px) 94vw, (max-width: 1199px) calc(94vw - 420px), (max-width: 1439px) calc(94vw - 516px), 828px';
  var MAX_THUMBS = 6; // BUILD-SPEC §5.4; the Liquid payload is capped the same way (lp-buy-box-color-media)
  var THUMB_LABEL = 'Image [n] of [total]';

  /* Colour names compare case-insensitively with spaces, underscores and hyphens equivalent
     ("Light Blue" = "light-blue" = "LIGHT_BLUE"), like Liquid's handleize on both sides. */
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().trim().replace(/[\s_-]+/g, '-');
  }

  /* ?color= values from before the colourway rename (old ad deep links), in norm() form -> the new
     names, also in norm() form. Used only when the wanted colour isn't one of the product's own
     colours, and the first candidate the product actually has wins: "sand-white" stays Sand White on
     the Como (which kept the name) and opens Off White on the Torino; "moss-green" opens Sage on the
     Torino and Olive on the Monte City; "navy" opens Navy on the Torino and Slate Blue on the Monte.
     "white-light-blue" is the handleized spelling of White/Light Blue. */
  var COLOR_ALIASES = {
    'midnight-black': ['black'],
    'black-fleece': ['black'],
    'sand-white': ['off-white'],
    'light-blue': ['white/light-blue'],
    'white-light-blue': ['white/light-blue'],
    'dark-navy': ['navy'],
    'navy': ['slate-blue'],
    'moss-green': ['sage', 'olive'],
    'soft-blue': ['french-blue'],
    'brown': ['chocolate-brown'],
    'muted-teal': ['teal'],
    'khaki': ['olive'],
    'khaki-green': ['olive'],
    'gray-purple': ['lilac-gray'],
  };

  /* Shopify CDN URL with a given width (payload URLs carry "width=1800"). */
  function sized(src, width) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function img(src, width, opts) {
    var el = document.createElement('img');
    el.src = sized(src, width);
    el.alt = (opts && opts.alt) || '';
    el.loading = (opts && opts.loading) || 'lazy';
    el.decoding = 'async';
    if (opts && opts.w && opts.h) {
      el.width = opts.w;
      el.height = opts.h;
    }
    if (opts && opts.srcset) {
      el.srcset = opts.srcset;
      el.sizes = opts.sizes || '100vw';
    }
    if (opts && opts.className) el.className = opts.className;
    return el;
  }

  LP.register('buy-box', function (root) {
    var products = {};
    LP.qsa('script[data-lp-product]', root).forEach(function (el) {
      var data = LP.json(el);
      if (data && data.id) products[el.getAttribute('data-lp-product')] = data;
    });
    var slots = Object.keys(products);
    if (!slots.length) return;

    var uid = 'lp-buy-box-' + (root.getAttribute('data-section-id') || Math.random().toString(36).slice(2));
    var labels = {
      select: root.getAttribute('data-label-select') || '',
      add: root.getAttribute('data-label-add') || '',
      added: root.getAttribute('data-label-added') || '',
      soldOut: root.getAttribute('data-label-sold-out') || '',
      thumb: root.getAttribute('data-label-thumb') || THUMB_LABEL,
    };
    var okendoStore = root.getAttribute('data-okendo-store');
    var isOwner = LP.claimStateOwner(root);

    var els = {
      main: LP.qs('[data-lp-main]', root),
      thumbs: LP.qs('[data-lp-thumbs]', root),
      swatches: LP.qs('[data-lp-swatches]', root),
      colorName: LP.qs('[data-lp-color-name]', root),
      sizes: LP.qs('[data-lp-sizes]', root),
      form: LP.qs('[data-lp-form]', root),
      atc: LP.qs('[data-lp-atc]', root),
      error: LP.qs('[data-lp-error]', root),
      status: LP.qs('[data-lp-status]', root),
    };
    if (els.form) els.form.setAttribute('novalidate', '');

    var initialSlot = products[root.getAttribute('data-slot')] ? root.getAttribute('data-slot') : slots[0];
    var state = {
      slot: initialSlot,
      color: defaultColorOf(products[initialSlot]),
      image: 0,
      variant: null,
      added: false,
      busy: false,
    };
    var ready = false; // true once init is done: only later changes are the shopper's (URL writes)

    /* ---------- data helpers ---------- */

    function product() {
      return products[state.slot];
    }

    function defaultColorOf(p) {
      var i = Number(p && p.defaultColor) || 0;
      return p && p.colors && p.colors[i] ? i : 0;
    }

    /* Index of a colour by name (normalised), or -1. */
    function findColor(p, name) {
      var want = norm(name);
      if (!want) return -1;
      for (var i = 0; i < p.colors.length; i++) {
        if (norm(p.colors[i].name) === want) return i;
      }
      return -1;
    }

    /* findColor for a ?color= value: falls back to the new name of an old colour (COLOR_ALIASES),
       but only to a colour this product has. */
    function findUrlColor(p, name) {
      var i = findColor(p, name);
      var key = norm(name);
      var alts = i < 0 && Object.prototype.hasOwnProperty.call(COLOR_ALIASES, key) ? COLOR_ALIASES[key] : [];
      for (var k = 0; i < 0 && k < alts.length; k++) i = findColor(p, alts[k]);
      return i;
    }

    function colorOf(p) {
      return p.colors[state.color] || p.colors[0] || { name: '', media: [] };
    }

    function gallery(p) {
      return colorOf(p)
        .media.map(function (i) {
          return p.media[i];
        })
        .filter(Boolean)
        .slice(0, MAX_THUMBS);
    }

    function sizeLabel(p, v) {
      return p.sizeIndex >= 0 ? v.o[p.sizeIndex] : v.o.join(' / ');
    }

    /* Variants of the active colour, one per size (first available wins), in variant order. */
    function sizesFor(p) {
      var colorName = colorOf(p).name;
      var bySize = {};
      var list = [];
      p.variants.forEach(function (v) {
        if (p.colorIndex >= 0 && v.o[p.colorIndex] !== colorName) return;
        var label = sizeLabel(p, v);
        if (!(label in bySize)) {
          bySize[label] = list.length;
          list.push({ label: label, variant: v });
        } else if (!list[bySize[label]].variant.a && v.a) {
          list[bySize[label]].variant = v;
        }
      });
      return list;
    }

    function colorPrice(p) {
      var list = sizesFor(p);
      var pick = list.filter(function (s) { return s.variant.a; })[0] || list[0];
      return pick ? pick.variant.p : p.variants[0] && p.variants[0].p;
    }

    /* Variant the PDP link opens: the selected one, else the active colour's first available
       variant, else its first variant (D69: the colour carries over to the product page). */
    function pdpVariant(p) {
      if (state.variant) return state.variant;
      var colorName = colorOf(p).name;
      var ofColor = p.variants.filter(function (v) {
        return p.colorIndex < 0 || v.o[p.colorIndex] === colorName;
      });
      return ofColor.filter(function (v) { return v.a; })[0] || ofColor[0] || p.variants[0] || null;
    }

    function pdpUrl(p) {
      var v = pdpVariant(p);
      if (!v) return p.url;
      return p.url + (p.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id;
    }

    function altFor(p, m) {
      if (m && m.alt) return m.alt;
      return [p.title, colorOf(p).name].filter(Boolean).join(', ');
    }

    /* ---------- rendering ---------- */

    function setText(sel, text) {
      LP.qsa(sel, root).forEach(function (el) {
        el.textContent = text;
      });
    }

    function renderMain() {
      if (!els.main) return;
      var p = product();
      var list = gallery(p);
      var m = list[state.image] || list[0];
      var current = els.main.querySelector('img');
      if (!m) return;
      var srcset = MAIN_WIDTHS.map(function (w) {
        return sized(m.src, w) + ' ' + w + 'w';
      }).join(', ');
      if (current && current.tagName === 'IMG') {
        current.src = sized(m.src, 1800);
        current.srcset = srcset;
        current.alt = altFor(p, m);
        if (m.w && m.h) {
          current.width = m.w;
          current.height = m.h;
        }
      } else {
        els.main.textContent = '';
        els.main.appendChild(
          img(m.src, 1800, {
            alt: altFor(p, m),
            w: m.w,
            h: m.h,
            srcset: srcset,
            sizes: MAIN_SIZES,
            className: 'lp-buy-box__main-img',
          })
        );
      }
    }

    function renderThumbs() {
      if (!els.thumbs) return;
      var list = gallery(product());
      els.thumbs.textContent = '';
      list.forEach(function (m, i) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lp-buy-box__thumb';
        btn.setAttribute('data-index', String(i));
        btn.setAttribute('aria-pressed', i === state.image ? 'true' : 'false');
        btn.setAttribute('aria-label', labels.thumb.replace(/\[n\]/g, String(i + 1)).replace(/\[total\]/g, String(list.length)));
        btn.appendChild(img(m.src, 300, { w: m.w, h: m.h }));
        li.appendChild(btn);
        els.thumbs.appendChild(li);
      });
      els.thumbs.hidden = list.length < 2;
    }

    function syncThumbs() {
      LP.qsa('.lp-buy-box__thumb', els.thumbs || root).forEach(function (btn) {
        btn.setAttribute('aria-pressed', Number(btn.getAttribute('data-index')) === state.image ? 'true' : 'false');
      });
    }

    function renderSwatches() {
      if (!els.swatches) return;
      var p = product();
      els.swatches.textContent = '';
      p.colors.forEach(function (c, i) {
        var id = uid + '-color-' + i;
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'lp-sr-only lp-buy-box__swatch-input';
        input.name = uid + '-color';
        input.id = id;
        input.value = c.name;
        input.setAttribute('data-index', String(i));
        input.checked = i === state.color;
        var label = document.createElement('label');
        label.className = 'lp-buy-box__swatch';
        label.htmlFor = id;
        label.title = c.name;
        var first = p.media[c.media[0]];
        if (first) label.appendChild(img(first.src, 160, { w: first.w, h: first.h }));
        var sr = document.createElement('span');
        sr.className = 'lp-sr-only';
        sr.textContent = c.name;
        label.appendChild(sr);
        els.swatches.appendChild(input);
        els.swatches.appendChild(label);
      });
      var group = els.swatches.closest('.lp-buy-box__group');
      if (group) group.hidden = !p.colors.length || (p.colors.length === 1 && !p.colors[0].name);
    }

    /* D78 / BUILD-SPEC §2: up to 6 sizes on one row at every width (phones keep the desktop
       columns); more fall back to the CSS default of 5 columns. Mirrors lp-buy-box.liquid. */
    function sizeColumns(n) {
      var st = els.sizes.style;
      els.sizes.setAttribute('data-size-count', String(n));
      if (n > 0 && n <= 6) {
        st.setProperty('--lp-size-cols', String(n));
        st.setProperty('--lp-size-cols-phone', String(n));
      } else {
        st.removeProperty('--lp-size-cols');
        st.removeProperty('--lp-size-cols-phone');
      }
    }

    function renderSizes() {
      if (!els.sizes) return;
      var p = product();
      var list = sizesFor(p);
      els.sizes.textContent = '';
      sizeColumns(list.length);
      list.forEach(function (s) {
        var v = s.variant;
        var id = uid + '-size-' + v.id;
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'lp-sr-only lp-buy-box__size-input';
        input.name = 'id';
        input.id = id;
        input.value = String(v.id);
        input.required = true;
        input.disabled = !v.a;
        input.checked = !!(state.variant && state.variant.id === v.id);
        var label = document.createElement('label');
        label.className = 'lp-buy-box__size';
        label.htmlFor = id;
        label.textContent = s.label;
        if (!v.a && labels.soldOut) {
          var sr = document.createElement('span');
          sr.className = 'lp-sr-only';
          sr.textContent = ', ' + labels.soldOut;
          label.appendChild(sr);
        }
        els.sizes.appendChild(input);
        els.sizes.appendChild(label);
      });
    }

    function renderCta() {
      if (!els.atc) return;
      var p = product();
      var anyAvailable = sizesFor(p).some(function (s) { return s.variant.a; });
      var text;
      if (state.added) text = labels.added;
      else if (state.variant) text = labels.add + ' · ' + LP.money(state.variant.p, { trim: true });
      else if (!anyAvailable) text = labels.soldOut;
      else text = labels.select;
      els.atc.textContent = text;
      els.atc.setAttribute('aria-disabled', state.variant ? 'false' : 'true');
      if (state.busy) els.atc.setAttribute('aria-busy', 'true');
      else els.atc.removeAttribute('aria-busy');
    }

    function renderProductText() {
      var p = product();
      setText('[data-lp-name]', p.title);
      setText('[data-lp-price]', LP.money(state.variant ? state.variant.p : colorPrice(p)));
      setText('[data-lp-color-name]', colorOf(p).name);
      setText('[data-lp-rating]', p.rating);
      setText('[data-lp-count]', String(p.count));
      LP.qsa('[data-lp-rating-line]', root).forEach(function (el) {
        el.hidden = !p.rating;
      });
      var details = pdpUrl(p);
      LP.qsa('[data-lp-details]', root).forEach(function (a) {
        a.href = details;
      });
      LP.qsa('[data-lp-slot]', root).forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-lp-slot') === state.slot ? 'true' : 'false');
      });
    }

    function clearMessages() {
      if (els.error) els.error.textContent = '';
      if (els.status) els.status.textContent = '';
    }

    /* Publish the page-wide product state (owner only). */
    function publish() {
      if (!isOwner) return;
      var p = product();
      var first = gallery(p)[0];
      var v = state.variant;
      LP.setState({
        product: state.slot,
        productId: p.id,
        productTitle: p.title,
        label: p.label,
        url: p.url,
        colorName: colorOf(p).name,
        size: v ? sizeLabel(p, v) : '',
        variantId: v ? v.id : null,
        available: v ? !!v.a : null,
        price: v ? v.p : colorPrice(p),
        image: first ? first.src : '',
        imageAlt: first ? altFor(p, first) : '',
        rating: p.rating,
        count: p.count,
        busy: state.busy,
        added: state.added,
        addedLabel: labels.added,
      });
    }

    /* D69: keep the shopper's gender and colour in the URL (ad deep links, webview reloads).
       Other params (utm_*, view=…) and the hash stay; a stale ?variant= is dropped. */
    function writeUrl() {
      if (!ready || !isOwner || LP.designMode) return;
      if (!window.history || !history.replaceState || typeof URL !== 'function') return;
      try {
        var p = product();
        var url = new URL(window.location.href);
        var params = url.searchParams;
        // gender= only means something with the toggle (two products).
        var gender = slots.length > 1 ? String(p.label || '').trim().toLowerCase() : '';
        var color = norm(colorOf(p).name);
        if (gender) params.set('gender', gender);
        else params.delete('gender');
        if (color) params.set('color', color);
        else params.delete('color');
        params.delete('variant');
        var search = params.toString();
        history.replaceState(history.state, '', url.pathname + (search ? '?' + search : '') + url.hash);
      } catch (e) {
        /* file:// or a sandboxed frame: the URL just doesn't follow */
      }
    }

    /* ---------- actions ---------- */

    function resetSelection() {
      state.variant = null;
      state.added = false;
      clearMessages();
    }

    function renderAll() {
      renderSwatches();
      renderSizes();
      renderMain();
      renderThumbs();
      renderProductText();
      renderCta();
    }

    function setProduct(slot) {
      if (!products[slot]) return;
      if (slot === state.slot) {
        publish();
        return;
      }
      state.slot = slot;
      state.color = defaultColorOf(products[slot]);
      state.image = 0;
      resetSelection();
      renderAll();
      publish();
      writeUrl();
      refreshRating();
    }

    function setColor(index) {
      var p = product();
      if (!p.colors[index] || index === state.color) return;
      // Keep the chosen size across a colour change (design); clear it only when the new colour
      // has no available variant in that size.
      var keep = state.variant ? sizeLabel(p, state.variant) : null;
      state.color = index;
      state.image = 0;
      state.added = false;
      clearMessages();
      var hit = keep
        ? sizesFor(p).filter(function (s) {
            return s.label === keep && s.variant.a;
          })[0]
        : null;
      state.variant = hit ? hit.variant : null;
      renderSizes();
      renderMain();
      renderThumbs();
      renderProductText();
      renderCta();
      publish();
      writeUrl();
    }

    function setImage(index) {
      state.image = index;
      renderMain();
      syncThumbs();
    }

    function setVariant(id) {
      var p = product();
      var match = sizesFor(p).filter(function (s) {
        return String(s.variant.id) === String(id);
      })[0];
      state.variant = match && match.variant.a ? match.variant : null;
      state.added = false;
      clearMessages();
      renderProductText();
      renderCta();
      publish();
    }

    /* Resolves 'added' | 'error' | 'skipped' (busy, or no size chosen). Busy / added are published
       so the product bar's button mirrors this one. */
    function addToCart() {
      if (state.busy) return Promise.resolve('skipped');
      if (!state.variant) {
        var firstSize = LP.qs('.lp-buy-box__size-input:not(:disabled)', root);
        if (firstSize) firstSize.focus();
        return Promise.resolve('skipped');
      }
      var variant = state.variant;
      var result = 'added';
      state.busy = true;
      clearMessages();
      renderCta();
      publish();
      return LP.addToCart(variant.id, 1)
        .then(function () {
          if (state.variant !== variant) return;
          state.added = true;
          if (els.status) els.status.textContent = labels.added;
        })
        .catch(function (err) {
          result = 'error';
          if (els.error) els.error.textContent = (err && err.message) || LP.CART_ERROR_TEXT;
        })
        .then(function () {
          state.busy = false;
          renderCta();
          publish();
          return result;
        });
    }

    /* ---------- URL preselect (D51) ---------- */

    /* On load only: ?variant=<id> (either product; wins) selects its product, colour and, when
       available, size; else ?gender=<toggle label> (exact, case-insensitive) picks the product and
       ?color=<name> its colour. Unknown values are ignored. Returns true when the selection changed. */
    function applyUrl() {
      if (!isOwner || LP.designMode || typeof URLSearchParams !== 'function') return false;
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return false;
      }
      var slot = state.slot;
      var color = state.color;
      var variant = null;

      var vid = String(params.get('variant') || '').trim();
      var hit = null;
      if (/^\d+$/.test(vid)) {
        slots.forEach(function (s) {
          products[s].variants.forEach(function (v) {
            if (!hit && String(v.id) === vid) hit = { slot: s, v: v };
          });
        });
      }

      if (hit) {
        var hp = products[hit.slot];
        slot = hit.slot;
        color = defaultColorOf(hp);
        if (hp.colorIndex >= 0) {
          var name = hit.v.o[hp.colorIndex];
          var exact = -1;
          hp.colors.forEach(function (c, i) {
            if (exact < 0 && c.name === name) exact = i;
          });
          var ci = exact >= 0 ? exact : findColor(hp, name);
          if (ci >= 0) color = ci;
        }
        if (hit.v.a) variant = hit.v;
      } else {
        var gender = String(params.get('gender') || '').trim().toLowerCase();
        if (gender) {
          slots.forEach(function (s) {
            if (String(products[s].label || '').trim().toLowerCase() === gender) slot = s;
          });
        }
        if (slot !== state.slot) color = defaultColorOf(products[slot]);
        var wanted = params.get('color');
        if (wanted) {
          var idx = findUrlColor(products[slot], wanted);
          if (idx >= 0) color = idx;
        }
      }

      if (slot === state.slot && color === state.color && !variant) return false;
      state.slot = slot;
      state.color = color;
      state.image = 0;
      state.variant = null;
      state.added = false;
      if (variant) {
        var p = products[slot];
        var list = sizesFor(p);
        var pick =
          list.filter(function (s) { return s.variant.id === variant.id; })[0] ||
          list.filter(function (s) { return s.label === sizeLabel(p, variant) && s.variant.a; })[0];
        state.variant = pick ? pick.variant : null;
      }
      renderAll();
      return true;
    }

    /* Live Okendo rating for the active product; keeps the settings figures on failure. */
    function refreshRating() {
      if (!okendoStore || !LP.okendoAggregate) return;
      var p = product();
      if (p.okendoDone) return;
      LP.okendoAggregate([p.id], okendoStore)
        .then(function (a) {
          p.okendoDone = true;
          p.rating = a.avgText;
          p.count = a.count;
          if (product() === p) {
            renderProductText();
            publish();
          }
        })
        .catch(function () {});
    }

    /* ---------- events ---------- */

    function onClick(e) {
      var slotBtn = e.target.closest('[data-lp-slot]');
      if (slotBtn && root.contains(slotBtn)) {
        LP.requestProduct(slotBtn.getAttribute('data-lp-slot'));
        return;
      }
      var thumb = e.target.closest('.lp-buy-box__thumb');
      if (thumb && root.contains(thumb)) setImage(Number(thumb.getAttribute('data-index')) || 0);
    }

    function onChange(e) {
      var t = e.target;
      if (t.classList.contains('lp-buy-box__swatch-input')) setColor(Number(t.getAttribute('data-index')) || 0);
      else if (t.classList.contains('lp-buy-box__size-input')) setVariant(t.value);
    }

    function onSubmit(e) {
      e.preventDefault();
      addToCart();
    }

    function onRequest(e) {
      if (e.detail && e.detail.product) setProduct(e.detail.product);
    }

    /* The product bar's "ADD TO CART · $129" (lp-sticky-bar) adds through this box. */
    function onRequestAdd(e) {
      if (!isOwner) return;
      var pending = addToCart();
      if (e.detail && typeof e.detail === 'object') e.detail.promise = pending;
    }

    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    if (els.form) els.form.addEventListener('submit', onSubmit);
    document.addEventListener('lp:request-product', onRequest);
    document.addEventListener('lp:request-add', onRequestAdd);

    if (!applyUrl()) {
      // The browser may restore a checked colour / size (back-forward navigation).
      var restoredColor = LP.qs('.lp-buy-box__swatch-input:checked', root);
      if (restoredColor && Number(restoredColor.getAttribute('data-index')) !== state.color) {
        setColor(Number(restoredColor.getAttribute('data-index')) || 0);
      }
      var restoredSize = LP.qs('.lp-buy-box__size-input:checked:not(:disabled)', root);
      if (restoredSize) setVariant(restoredSize.value);
    }
    renderCta();
    publish();
    refreshRating();
    ready = true;

    return function destroy() {
      root.removeEventListener('click', onClick);
      root.removeEventListener('change', onChange);
      if (els.form) els.form.removeEventListener('submit', onSubmit);
      document.removeEventListener('lp:request-product', onRequest);
      document.removeEventListener('lp:request-add', onRequestAdd);
      LP.releaseStateOwner(root);
    };
  });
})();

/* ===== 10-fit.js ===== */
/* LP fit guidance (sections/lp-fit.liquid).
   The toggle asks the buy box to switch product (LP.requestProduct); the pressed state and the visible
   size chart follow the page's product state (chart block whose product is the active product, else
   the "coming soon" text). Without a buy box the toggle switches between the first and second chart.
   The toggle is global, so a shopper's click here is announced once in the section's polite live
   region (D69): "Showing the [product] size chart. The buy box above now shows [product] too."
   Page load and switches made elsewhere (buy box, closing CTA) are not announced. */
(function () {
  'use strict';
  var LP = window.LP;
  if (!LP) return;

  LP.register('fit', function (root) {
    var charts = LP.qsa('[data-lp-chart]', root);
    var empty = LP.qs('[data-lp-chart-empty]', root);
    var toggles = LP.qsa('[data-lp-slot]', root);
    var live = LP.qs('[data-lp-fit-status]', root);
    var switchText = root.getAttribute('data-switch-text') || '';
    var pending = null; // { slot, from } while a click here waits for the buy box to switch
    var lastProduct = null;

    /* Checked per click, not once at init: in the theme editor a buy box can be added or removed
       after this section has loaded. */
    function hasBuyBox() {
      return !!LP.qs('[data-lp="buy-box"] script[data-lp-product]');
    }

    function press(slot) {
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-lp-slot') === slot ? 'true' : 'false');
      });
    }

    function show(chart) {
      charts.forEach(function (c) {
        c.hidden = c !== chart;
      });
      if (empty) empty.hidden = !!chart;
    }

    /* The chart for the active product; a chart with no product picked stands in for its slot
       (first product-less chart for the primary product, second for the secondary). */
    function chartFor(productId, slot) {
      return (
        charts.filter(function (c) {
          return productId != null && c.getAttribute('data-product-id') === String(productId);
        })[0] ||
        charts.filter(function (c) {
          return !c.getAttribute('data-product-id');
        })[slot === 'secondary' ? 1 : 0] ||
        null
      );
    }

    function announce(title) {
      if (!live || !switchText || !title) return;
      var text = switchText.replace(/\[product\]/g, title);
      // Clear first so the same sentence is read again after switching back and forth.
      live.textContent = '';
      window.setTimeout(function () {
        live.textContent = text;
      }, 60);
    }

    function onState(s) {
      press(s.product);
      show(chartFor(s.productId, s.product));
      if (pending && s.product === pending.slot) {
        if (s.product !== pending.from) announce(s.productTitle);
        pending = null;
      }
      lastProduct = s.product;
    }

    function onClick(e) {
      var btn = e.target.closest('[data-lp-slot]');
      if (!btn || !root.contains(btn)) return;
      var slot = btn.getAttribute('data-lp-slot');
      if (!hasBuyBox()) {
        press(slot);
        show(charts[slot === 'secondary' ? 1 : 0] || null);
      } else {
        pending = { slot: slot, from: lastProduct };
        LP.requestProduct(slot);
        pending = null; // the buy box answers synchronously; never announce a later, unrelated change
      }
    }

    // Theme editor: reveal a chart block while it is selected.
    function onBlockSelect(e) {
      var target = e.detail && e.detail.target;
      var chart = target && target.closest ? target.closest('[data-lp-chart]') : null;
      if (chart && root.contains(chart)) show(chart);
    }

    root.addEventListener('click', onClick);
    root.addEventListener('lp:block-select', onBlockSelect);
    // Always subscribed: without a buy box nothing publishes, so the local toggle stays in charge.
    var unsubscribe = LP.subscribe(onState);

    return function destroy() {
      root.removeEventListener('click', onClick);
      root.removeEventListener('lp:block-select', onBlockSelect);
      unsubscribe();
    };
  });
})();

/* ===== 10-sticky-bar.js ===== */
/* LP product bar (sections/lp-sticky-bar.liquid).
   Mirrors the page's product state (name, price, rating, colour, thumbnail). Desktop: an overlay at the
   top (its wrapper is 0px tall); phone: a fixed bottom bar. Both are shown only while the buy box's
   add-to-cart button is out of view and the page is scrolled past the bar's height (D63).
   The button scrolls to the buy box (phone: to its size picker, focusing the sizes); once a size is
   picked there it reads "ADD TO CART · $129" and asks
   the buy box to add (document event 'lp:request-add'), mirroring its busy / added state. */
(function () {
  'use strict';
  var LP = window.LP;
  if (!LP) return;

  var PHONE_BAR_H = 64;

  function sized(src, width) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  LP.register('sticky-bar', function (root) {
    var phoneBar = root.hasAttribute('data-phone-bar');
    var fitText = root.getAttribute('data-fit-text') || '';
    var sectionId = root.getAttribute('data-section-id');
    var el = {
      name: LP.qs('[data-lp-bar-name]', root),
      price: LP.qs('[data-lp-bar-price]', root),
      rating: LP.qs('[data-lp-bar-rating]', root),
      count: LP.qs('[data-lp-bar-count]', root),
      color: LP.qs('[data-lp-bar-color]', root),
      sep: LP.qs('[data-lp-bar-sep]', root),
      thumb: LP.qs('[data-lp-bar-thumb]', root),
      cta: LP.qs('[data-lp-bar-cta]', root),
    };
    var ctaLabels = {
      scroll: el.cta ? el.cta.textContent.trim() : '',
      add: root.getAttribute('data-label-add') || '',
    };
    var ctaMode = 'scroll';

    /* ---- Button: scroll to the buy box, or add the selected size through it ---- */

    function renderCta(s) {
      if (!el.cta) return;
      var add = !!(s && s.variantId && s.available !== false && ctaLabels.add);
      var text = ctaLabels.scroll;
      if (add) {
        text = s.added && s.addedLabel ? s.addedLabel : ctaLabels.add + ' · ' + LP.money(s.price, { trim: true });
      }
      if (el.cta.textContent !== text) el.cta.textContent = text;
      if (add) el.cta.setAttribute('role', 'button');
      else el.cta.removeAttribute('role');
      if (add && s.busy) el.cta.setAttribute('aria-busy', 'true');
      else el.cta.removeAttribute('aria-busy');
      var cta = add ? 'sticky-bar-add' : 'sticky-bar-cta';
      if (el.cta.getAttribute('data-lp-cta') !== cta) {
        el.cta.setAttribute('data-lp-cta', cta);
        if (typeof LP.stampCtas === 'function') LP.stampCtas(root);
      }
      ctaMode = add ? 'add' : 'scroll';
    }

    /* After a failed add, bring the buy box's sizes, button and role="alert" error into view. */
    function revealBuyBox() {
      var box = LP.qs('[data-lp="buy-box"]');
      if (!box) return;
      LP.scrollTo(LP.qs('[data-lp-sizes]', box) || box, { focus: false, updateHash: false });
      var atc = LP.qs('[data-lp-atc]', box);
      if (atc) {
        try {
          atc.focus({ preventScroll: true });
        } catch (e) {
          /* noop */
        }
      }
    }

    /* Phone, no size picked yet: land on the size picker (not the gallery at the top of the buy box),
       12px under the top like revealBuyBox(), and move focus into the size radiogroup (the checked
       size, else the first available one). The target is the colour group ("Color: ..." + swatches)
       when it, the sizes and the add-to-cart button fit on screen together, else the size group (its
       "Size" / "Size chart" label row on top); the bare grid only when neither group exists.
       Measured before scrolling. LP.scrollTo is instant under reduced motion. */
    function sizesTarget(box, sizes) {
      var sizeGroup = sizes.closest('.lp-buy-box__group');
      var swatches = LP.qs('[data-lp-swatches]', box);
      var colourGroup = swatches && swatches.closest('.lp-buy-box__group');
      var atc = LP.qs('[data-lp-atc]', box);
      if (colourGroup && !colourGroup.hidden && atc && colourGroup.getClientRects().length) {
        var offset = typeof LP.stickyOffset === 'function' ? LP.stickyOffset(colourGroup) : 0;
        var span = atc.getBoundingClientRect().bottom - colourGroup.getBoundingClientRect().top;
        // innerHeight - 16 when no sticky header (LP.scrollTo lands 12px under it; 4px to spare).
        if (span <= window.innerHeight - offset - 16) return colourGroup;
      }
      return sizeGroup || colourGroup || sizes;
    }

    function scrollToSizes(e) {
      var box = LP.qs('[data-lp="buy-box"]');
      var sizes = box && LP.qs('[data-lp-sizes]', box);
      if (!sizes) return; // no buy box / sizes: the core's anchor delegation handles the link
      e.preventDefault();
      LP.scrollTo(sizesTarget(box, sizes), { focus: false, updateHash: false });
      var input =
        LP.qs('.lp-buy-box__size-input:checked:not(:disabled)', sizes) ||
        LP.qs('.lp-buy-box__size-input:not(:disabled)', sizes);
      if (input) {
        try {
          input.focus({ preventScroll: true });
        } catch (err) {
          /* noop */
        }
      }
    }

    function onCtaClick(e) {
      if (ctaMode !== 'add') {
        // Desktop: the core's anchor delegation scrolls to the buy box (#buy) and focuses it.
        if (mq.matches && !e.defaultPrevented && !(e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
          scrollToSizes(e);
        }
        return;
      }
      e.preventDefault();
      var ev = new CustomEvent('lp:request-add', { detail: {} });
      document.dispatchEvent(ev);
      var pending = ev.detail && ev.detail.promise;
      if (pending && typeof pending.then === 'function') {
        pending.then(function (result) {
          if (result === 'error') revealBuyBox();
        });
      } else {
        revealBuyBox(); // no buy box answered
      }
    }

    // In add mode the link acts as a button (role="button"), so Space activates it too.
    function onCtaKey(e) {
      if (ctaMode !== 'add' || (e.key !== ' ' && e.key !== 'Spacebar')) return;
      e.preventDefault();
      el.cta.click();
    }

    /* ---- Product state ---- */

    function render(s) {
      if (!s || !s.productTitle) return;
      if (el.name) el.name.textContent = s.productTitle;
      if (el.price && s.price != null) el.price.textContent = LP.money(s.price, { trim: true });
      if (el.rating && s.rating) el.rating.textContent = s.rating;
      if (el.count && s.count != null) el.count.textContent = String(s.count);
      if (el.color) el.color.textContent = s.colorName || '';
      if (el.sep) el.sep.textContent = s.colorName && fitText ? ' · ' : '';
      if (root.hasAttribute('aria-label')) root.setAttribute('aria-label', s.productTitle);
      if (el.thumb && s.image) {
        var src = sized(s.image, 120);
        var current = el.thumb.querySelector('img');
        if (!current || current.tagName !== 'IMG') {
          el.thumb.textContent = '';
          current = document.createElement('img');
          current.alt = '';
          current.width = 60;
          current.height = 60;
          current.loading = 'lazy';
          current.decoding = 'async';
          el.thumb.appendChild(current);
        }
        if (current.getAttribute('src') !== src) {
          current.removeAttribute('srcset');
          current.removeAttribute('sizes');
          current.src = src;
        }
      }
      renderCta(s);
    }

    var unsubscribe = LP.subscribe(render);

    /* ---- Visibility (both breakpoints) ----
       Shown while the buy box's add-to-cart button is out of view AND either above the viewport or
       the whole buy box is off screen (e.g. the 2b pitch above it), AND the page is scrolled past the
       bar's height (never over the first section on load). No buy box: shown once scrolled. Theme
       editor: also shown while this section is selected. */
    var observer = null;
    var observed = null;
    var atcInView = false;
    var atcAbove = false;
    var boxInView = false;
    var scrolledPast = false;
    var editorSelected = false;
    var shown = null;
    var shownPhone = null;
    var mq = window.matchMedia('(max-width: 749.98px)');

    function barHeight() {
      return root.offsetHeight || (mq.matches ? PHONE_BAR_H : 76);
    }

    function isPast() {
      return (window.pageYOffset || document.documentElement.scrollTop || 0) > barHeight();
    }

    function setTopBar(visible) {
      var h = visible ? barHeight() : 0;
      if (typeof LP.setTopBar === 'function') LP.setTopBar(visible, h);
      else document.documentElement.style.setProperty('--lp-top-bar-h', h + 'px');
    }

    function update() {
      scrolledPast = isPast();
      var phone = mq.matches;
      var enabled = phone ? phoneBar : true;
      var offScreen = !observed || (!atcInView && (atcAbove || !boxInView));
      var show = enabled && (editorSelected || (offScreen && scrolledPast));
      if (show === shown && phone === shownPhone) return;
      shown = show;
      shownPhone = phone;
      root.classList.toggle('is-visible', show);
      if (phone) {
        setTopBar(false);
        LP.setBottomBar(show, PHONE_BAR_H);
      } else {
        LP.setBottomBar(false);
        setTopBar(show);
      }
    }

    function watchAtc() {
      var atc = LP.qs('[data-lp="buy-box"] [data-lp-atc]');
      if (atc === observed) {
        update();
        return;
      }
      if (observer) observer.disconnect();
      observer = null;
      observed = atc;
      // Stay hidden until the observer has reported where the button is (and for good
      // without IntersectionObserver, rather than cover the buy box).
      atcInView = true;
      atcAbove = false;
      boxInView = true;
      if (atc && 'IntersectionObserver' in window) {
        var box = atc.closest('[data-lp="buy-box"]');
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === atc) {
              atcInView = entry.isIntersecting;
              atcAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              boxInView = entry.isIntersecting;
            }
          });
          // An instant jump (reduced-motion LP.scrollTo) can carry the button from above the viewport
          // to below it without an ATC entry; re-derive its side whenever either target reports.
          if (!atcInView) atcAbove = atc.getBoundingClientRect().bottom < 0;
          update();
        });
        observer.observe(atc);
        if (box) observer.observe(box);
      }
      update();
    }

    function onState() {
      // The buy box may have been re-rendered (theme editor); re-attach to its button.
      if (!observed || !document.documentElement.contains(observed)) watchAtc();
    }

    // The scroll threshold is the one input IntersectionObserver cannot report.
    var ticking = false;
    var lastY = window.pageYOffset || 0;
    function onScroll() {
      lastY = window.pageYOffset || 0;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (isPast() !== scrolledPast) update();
      });
    }

    /* Focusing the bar's button (click or Tab) makes Chrome "scroll it into view": it sits inside the
       html scroll-padding band kept clear for this very bar, so the page jumped ~450px although the
       bar never moves. Undo that jump (the scroll event has not fired yet, so lastY is the old spot). */
    function onFocusIn() {
      var y = window.pageYOffset || 0;
      if (Math.abs(y - lastY) < 2) return;
      try {
        window.scrollTo({ top: lastY, left: window.pageXOffset || 0, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(window.pageXOffset || 0, lastY);
      }
    }

    function onMedia() {
      shown = null; // breakpoint change: re-apply the top / bottom bar reservations
      update();
    }

    function onSectionSelect(e) {
      if (!e.detail || String(e.detail.sectionId) !== String(sectionId)) return;
      editorSelected = e.type === 'shopify:section:select';
      update();
    }

    if (el.cta) {
      el.cta.addEventListener('click', onCtaClick);
      el.cta.addEventListener('keydown', onCtaKey);
    }
    root.addEventListener('focusin', onFocusIn);
    if (mq.addEventListener) mq.addEventListener('change', onMedia);
    else if (mq.addListener) mq.addListener(onMedia);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('lp:state', onState);
    if (LP.designMode) {
      document.addEventListener('shopify:section:select', onSectionSelect);
      document.addEventListener('shopify:section:deselect', onSectionSelect);
    }
    watchAtc();

    return function destroy() {
      unsubscribe();
      if (el.cta) {
        el.cta.removeEventListener('click', onCtaClick);
        el.cta.removeEventListener('keydown', onCtaKey);
      }
      root.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('lp:state', onState);
      document.removeEventListener('shopify:section:select', onSectionSelect);
      document.removeEventListener('shopify:section:deselect', onSectionSelect);
      window.removeEventListener('scroll', onScroll);
      if (mq.removeEventListener) mq.removeEventListener('change', onMedia);
      else if (mq.removeListener) mq.removeListener(onMedia);
      if (observer) observer.disconnect();
      root.classList.remove('is-visible');
      LP.setBottomBar(false);
      setTopBar(false);
    };
  });
})();

/* ===== 20-pain-map.js ===== */
/* LP · Pain map (sections/lp-pain-map.liquid)
   One active point at a time. Triggers are the hotspots and the rows
   ([data-lp-pain-point="<index>"], grouped by [data-lp-pain-group]); the
   matching pane ([data-lp-pain-pane]) is shown. Arrow keys / Home / End move
   between triggers of the same group and activate them. Selecting a point
   block in the theme editor activates it.
   Phones: clicking/tapping a hotspot (or Enter/Space on it) scrolls the page
   just enough to show the whole detail panel, which sits below the rows; focus
   stays on the hotspot. Rows sit next to the panel, and arrow keys keep the
   focused hotspot in view, so neither scrolls. */
(function () {
  'use strict';
  var LP = window.LP;
  if (!LP || !LP.register) return;

  LP.register('pain-map', function (root) {
    var triggers = LP.qsa('[data-lp-pain-point]', root);
    var panes = LP.qsa('[data-lp-pain-pane]', root);
    var detail = LP.qs('.lp-pain-map__detail', root);
    if (!triggers.length) return;

    // Height of the phone bottom buy bar when it is showing (LP.setBottomBar).
    function bottomBarHeight() {
      if (!document.body.classList.contains('lp-has-bottom-bar')) return 0;
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lp-bottom-bar-h'));
      return isNaN(h) ? 64 : h;
    }

    // Phones only: scroll the least distance that shows the whole panel
    // between the sticky chrome and the bottom bar (its top edge if it is
    // taller than that space). No focus change, no hash change.
    function revealDetail() {
      if (!detail || !LP.isPhone()) return;
      var r = detail.getBoundingClientRect();
      var top = LP.stickyOffset() + 12;
      var bottom = window.innerHeight - bottomBarHeight() - 12;
      var delta = 0;
      if (r.bottom > bottom) delta = r.bottom - bottom;
      if (r.top - delta < top) delta = r.top - top;
      if (Math.abs(delta) < 1) return;
      window.scrollBy({ top: delta, behavior: LP.reducedMotion() ? 'auto' : 'smooth' });
    }

    function activate(index) {
      var key = String(index);
      if (!panes.some(function (p) { return p.getAttribute('data-lp-pain-pane') === key; })) return;
      triggers.forEach(function (t) {
        t.setAttribute('aria-pressed', t.getAttribute('data-lp-pain-point') === key ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-lp-pain-pane') === key;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('aria-hidden');
        else p.setAttribute('aria-hidden', 'true');
      });
    }

    function onClick(e) {
      var t = e.target.closest('[data-lp-pain-point]');
      if (!t || !root.contains(t)) return;
      activate(t.getAttribute('data-lp-pain-point'));
      if (t.getAttribute('data-lp-pain-group') === 'dots') revealDetail();
    }

    function onKeydown(e) {
      var t = e.target.closest('[data-lp-pain-point]');
      if (!t || !root.contains(t)) return;
      var group = triggers.filter(function (x) {
        return x.getAttribute('data-lp-pain-group') === t.getAttribute('data-lp-pain-group');
      });
      var i = group.indexOf(t);
      var next = -1;
      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = (i + 1) % group.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = (i - 1 + group.length) % group.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = group.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      group[next].focus();
      activate(group[next].getAttribute('data-lp-pain-point'));
    }

    // Theme editor: selecting a point block (its row <li> carries data-block-id).
    function onBlockSelect(e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      var items = LP.qsa('[data-block-id]', root);
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-block-id') === id) {
          var t = items[i].querySelector('[data-lp-pain-point]');
          if (t) activate(t.getAttribute('data-lp-pain-point'));
          return;
        }
      }
    }

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('lp:block-select', onBlockSelect);

    return function destroy() {
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeydown);
      root.removeEventListener('lp:block-select', onBlockSelect);
    };
  });
})();

/* ===== 30-hero-split.js ===== */
/* LP · Hero split: refresh the rating stat from Okendo when the section lists
   review products (data-review-products="id,id"). Server-rendered values stay
   if the request fails. */
(function () {
  'use strict';
  var LP = window.LP;
  if (!LP || !LP.register) return;

  LP.register('hero-split', function (root) {
    var ids = (root.getAttribute('data-review-products') || '').split(',').filter(Boolean);
    var avgEl = LP.qs('[data-lp-rating-avg]', root);
    var countEl = LP.qs('[data-lp-rating-count]', root);
    if (!ids.length || !avgEl || !LP.okendoAggregate) return;

    var alive = true;
    LP.okendoAggregate(ids, root.getAttribute('data-okendo-store') || undefined)
      .then(function (agg) {
        if (!alive) return;
        avgEl.textContent = agg.avgText;
        if (countEl) countEl.textContent = String(agg.count);
      })
      .catch(function () {});

    return function destroy() {
      alive = false;
    };
  });
})();

/* ===== 40-compare.js ===== */
/* LP · Compare (sections/lp-compare.liquid), "Pick your pair" buttons row (D69).
   A button whose column has a secondary link carries data-lp-href-primary and
   data-lp-href-secondary; its href follows the buy box's product toggle
   (LP.state.product). Without JS, or before the buy box publishes, the
   server-rendered primary link stays. Columns without a secondary link are
   never touched. */
(function () {
  'use strict';
  if (!window.LP) return;
  var LP = window.LP;

  LP.register('compare', function (root) {
    var buttons = LP.qsa('[data-lp-href-secondary]', root);
    if (!buttons.length) return;

    function sync(state) {
      var useSecondary = !!state && state.product === 'secondary';
      buttons.forEach(function (btn) {
        var primary = btn.getAttribute('data-lp-href-primary');
        var secondary = btn.getAttribute('data-lp-href-secondary');
        var href = useSecondary && secondary ? secondary : primary;
        if (href && btn.getAttribute('href') !== href) btn.setAttribute('href', href);
      });
    }

    return LP.subscribe(sync);
  });
})();

/* ===== 40-faq.js ===== */
/* LP · FAQ (sections/lp-faq.liquid)
   Independent accordions: each [data-lp-faq-toggle] flips its own aria-expanded and the
   `hidden` state of the region it controls. Selecting an item block in the theme editor
   opens it. */
(function () {
  'use strict';
  if (!window.LP) return;
  var LP = window.LP;

  function setOpen(button, open) {
    var region = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (region) region.hidden = !open;
  }

  LP.register('faq', function (root) {
    function onClick(e) {
      var button = e.target.closest('[data-lp-faq-toggle]');
      if (!button || !root.contains(button)) return;
      setOpen(button, button.getAttribute('aria-expanded') !== 'true');
    }

    function onBlockSelect(e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;
      var item = LP.qsa('[data-lp-faq-item]', root).filter(function (el) {
        return el.getAttribute('data-block-id') === id;
      })[0];
      var button = item && LP.qs('[data-lp-faq-toggle]', item);
      if (button) setOpen(button, true);
    }

    root.addEventListener('click', onClick);
    root.addEventListener('lp:block-select', onBlockSelect);

    return function destroy() {
      root.removeEventListener('click', onClick);
      root.removeEventListener('lp:block-select', onBlockSelect);
    };
  });
})();

/* ===== 40-reviews.js ===== */
/* LP · Reviews (sections/lp-reviews.liquid) and LP · Standard panel stat card.
   Both server-render their numbers from settings; when products are set
   (data-okendo-products="id,id"), the live Okendo aggregate (summed across the products)
   replaces them. Any failure keeps the server-rendered numbers. */
(function () {
  'use strict';
  if (!window.LP) return;
  var LP = window.LP;

  function okendoIds(root) {
    return (root.getAttribute('data-okendo-products') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  /* Fill a [data-template] element's "[count]" with the live count and show it
     (it is server-hidden when the settings had no count to put there). */
  function setCount(el, count) {
    if (!el) return;
    var tpl = el.getAttribute('data-template') || '';
    setText(el, tpl.split('[count]').join(String(count)));
    if (el.hidden) el.hidden = false;
  }

  function withAggregate(root, render) {
    var ids = okendoIds(root);
    if (!ids.length || typeof LP.okendoAggregate !== 'function') return;
    var alive = true;
    LP.okendoAggregate(ids, root.getAttribute('data-okendo-store') || undefined)
      .then(function (agg) {
        if (alive && document.documentElement.contains(root)) render(agg);
      })
      .catch(function () {
        /* keep the server-rendered numbers */
      });
    return function destroy() {
      alive = false;
    };
  }

  LP.register('reviews', function (root) {
    return withAggregate(root, function (agg) {
      setText(LP.qs('[data-lp-reviews-avg]', root), agg.avgText);

      setCount(LP.qs('[data-lp-reviews-count]', root), agg.count);

      LP.qsa('[data-level]', root).forEach(function (row) {
        var n = Number(row.getAttribute('data-level'));
        var c = (agg.levels && agg.levels[n]) || 0;
        var pct = agg.count ? Math.round((c / agg.count) * 100) : 0;
        var fill = LP.qs('[data-lp-reviews-fill]', row);
        if (fill) fill.style.width = pct + '%';
        setText(LP.qs('[data-lp-reviews-level]', row), String(c));
        /* Screen-reader noun after the count: "1 review" / "N reviews". */
        setText(LP.qs('[data-lp-reviews-noun]', row), c === 1 ? ' review' : ' reviews');
      });

      setText(LP.qs('[data-lp-reviews-recommend]', root), agg.recommend + '%');
      setCount(LP.qs('[data-lp-reviews-basis]', root), agg.count);
    });
  });

  LP.register('standard-panel', function (root) {
    return withAggregate(root, function (agg) {
      setText(LP.qs('[data-lp-standard-stat]', root), agg.recommend + '%');
      setCount(LP.qs('[data-lp-standard-basis]', root), agg.count);
    });
  });
})();
